export default function () {
  return {
    countries_list: null,
    meta: null,
    faq: null,
    pagination: null,
    breadcrumb: null,
    testimonials: null,
    internalLinks: null
  }
}
